import Icon from '../components/Icon.vue'

Icon.register({"arrow-alt-circle-left":{"width":512,"height":512,"paths":[{"d":"M256 504C119 504 8 393 8 256S119 8 256 8 504 119 504 256 393 504 256 504zM372 212H256V141.1C256 130.4 243 125 235.5 132.6L121.2 247.5C116.5 252.2 116.5 259.7 121.2 264.4L235.5 379.3C243.1 386.9 256 381.5 256 370.8V300H372C378.6 300 384 294.6 384 288V224C384 217.4 378.6 212 372 212z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-alt-circle-left.js
// module id = V7QF
// module chunks = 0